import React, { useState } from 'react';
import API_BASE_URL from '../../config';
import PropTypes from 'prop-types';
import {
  Container,
  Segment,
  Header,
  Radio,
  Button,
  Message,
  Icon,
  Divider
} from 'semantic-ui-react';
import axios from 'axios';

// options: /api/next-step/ cevabındaki eşitlik ifadeleri [{ id, text }, …]
const TieBreaker = ({ options, sessionId, onComplete, userInfo }) => {
  const [selectedId, setSelectedId] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (!selectedId) return;
    setSubmitting(true);
    setError(null);

    try {
      await axios.post(`${API_BASE_URL}/api/tiebreaker/`, {
        session_id: sessionId,
        option_id: selectedId,
      });
      onComplete();
    } catch (err) {
      console.error("❌ Tie-breaker gönderimi başarısız:", err);
      setError(err?.response?.data?.error || "Seçiminiz kaydedilemedi. Lütfen tekrar deneyin.");
      setSubmitting(false);
    }
  };

  return (
    <Container>
      <Segment>
        <Header as="h2" textAlign="center" style={{ marginBottom: 30 }}>
          Sizi EN İYİ TANIMLAYAN ifadeyi seçin
        </Header>
        <Message floating size="large" icon>
          <Icon name="question circle outline" />
          <Message.Content>
  <Message.List>
    <Message.Item><strong>İsim:</strong> {userInfo.full_name}</Message.Item>
    <Message.Item><strong>Email:</strong> {userInfo.email}</Message.Item>
  </Message.List>

  <Divider />

  <div style={{
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#555',
    padding: '0.5rem 1rem',
    maxWidth: '100%',
    wordBreak: 'break-word',
  }}>
    <p>
      Her cümle size yakın gelebilir. Çünkü bu ifadeler sizde az ya da çok bulunur.
    </p>
    <p>
      <strong>Aşağıdaki ifadelerden sizi EN İYİ TANIMLAYAN ifadeyi seçin.</strong>
      <span style={{ marginLeft: '0.3rem' }}>Yalnızca <strong>BİR İFADE</strong> seçebilirsiniz.</span>
    </p>
    <p>
      Her ifadenin sizde var olabileceğini hatırlatalım ama amacınız <em>sizi en iyi tanımlayan ifadeyi</em> bulmak. 😊
    </p>
  </div>
</Message.Content>

        </Message>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {options.map((option) => (
            <Radio
              key={option.id}
              label={
                <label style={{ fontWeight: 'bold', cursor: 'pointer' }}>
                  {option.text}
                </label>
              }
              name="tiebreaker"
              value={option.id}
              checked={selectedId === option.id}
              onChange={() => setSelectedId(option.id)}
              style={{ marginBottom: 10 }}
            />
          ))}
        </div>

        {error && (
          <Message negative style={{ marginTop: 20 }}>
            {error}
          </Message>
        )}

        <Button
          primary
          disabled={!selectedId || submitting}
          onClick={handleSubmit}
          style={{ marginTop: 30 }}
          size="large"
          fluid
        >
          Devam Et
        </Button>

        {submitting && (
          <Message info style={{ marginTop: 20 }}>
            Gönderiliyor, lütfen bekleyin...
          </Message>
        )}
      </Segment>
    </Container>
  );
};

TieBreaker.propTypes = {
  options: PropTypes.array.isRequired,
  sessionId: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
};

export default TieBreaker;
